import React, {Component, Fragment} from "react";
import {withRouter} from "react-router-dom";
import { Card, CardBody, Button, Row, Col, Table } from "reactstrap";
import { User, List, Calendar, BookOpen } from "react-feather";
import Chip from "../../theme/@vuexy/chips/ChipComponent";
import { inject, observer } from 'mobx-react';
import Util from "../../utility/Util";
import Paginator from "../common/PaginatorComp";
import ActivityStore from "../../stores/activityStore";
import IActivity, { IActivityActor } from "../../types/IActivity";
import PaginatorComp from "../common/PaginatorComp";

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 6fr 1fr 2fr",
    padding: "1rem 0px",
    borderBottom: "1px solid #cacaca"
  },
  badge_visited: {
    backgroundColor: "#4cae4c",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "5px",
    width: "100%",
  },
  badge_shared: {
    backgroundColor: "#eea236",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "5px",
    width: "100%"
  },
  badge_attended: {
    backgroundColor: "#d9534f",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "5px",
    width: "100%"
  },
  badge_invited: {
    backgroundColor: "#7367f0",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "5px",
    width: "100%"
  },
  text_muted: {
    color: "#cacaca",
    fontSize: "14px"
  }

}

interface IActivityListProp {
  activityStore: ActivityStore,
  history: any
}

interface IActivityListState {

}

@inject('sessionStore', 'activityStore')
@observer
class ActivityList extends Component<IActivityListProp, IActivityListState> {


  componentDidMount = () =>{
    const { activityStore } = this.props;
    activityStore.loadActivities();
  }

  navigateTo = (entity:string, id:string) => {
    if(entity === 'meeting'){
      this.props.history.push("/meeting/view/"+ id)
    }else if(entity === 'customer'){
      this.props.history.push("/customer/view/"+ id)
    }else if(entity === 'content'){
      this.props.history.push("/library/view/"+id)
    }
  }

  onNext = (n:number) => {
    const { activityStore } = this.props;
    activityStore.setPaginator({ pageNumber: n });
    activityStore.loadCustomers();
  }

  onPrev = (n:number) => {
    const { activityStore } = this.props;
    activityStore.setPaginator({ pageNumber: n });
    activityStore.loadCustomers();
  }

  goToPage = (n:number) => {
    const { activityStore } = this.props;
    activityStore.setPaginator({ pageNumber: n });
    activityStore.loadCustomers();
  }

  render() {
    const { activityStore } = this.props;
    const { activityCollection, screen } = activityStore;
    const { paginator, activities} = activityCollection;

    const noData = (
      <div className="loading_conatiner">
        <div className="">
          <div>No Activities to Show</div>
        </div>
      </div>
    );
    
    const loading = (
      <div className="loading_conatiner">
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {/*<p>Message Here...</p>*/}
      </div>
    )

    const visitedComp = (act:IActivity) => {
      const customer = act.secondaryActors[0];
      const content = act.content || {};
      const timeago = Util.getSocialDate(act.time);

      return <div style={styles.grid}>
      <div className="text-left">
        <span className="mr-2" style={styles.badge_visited}>Visited</span>
      </div>
      <div className="d-flex align-items-center">
        <p className="mb-0">
          <span onClick={(e)=> this.navigateTo('','')}><u>{customer.name}</u></span>&nbsp;
          <span>visited</span>&nbsp;
          <span><u>{content.title}</u></span> for&nbsp;
          <span>{content.duration} seconds</span>
        </p>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <span style={styles.text_muted}>{timeago}</span>
      </div>
      <div className="text-center d-flex justify-content-around align-items-center">
        <User size={20} onClick={()=> {this.navigateTo('', '')}} />
        <BookOpen size={20} />
      </div>
    </div>
    }

    const sharedComp = (act:IActivity) => {
      const customer =  act.secondaryActors[0];
      const content = act.content || {};
      const timeago = Util.getSocialDate(act.time);
      return <div style={styles.grid}>
      <div className="text-left">
        <span className="mr-2" style={styles.badge_shared}>Shared</span>
      </div>
      <div className="d-flex align-items-center">
        <p className="mb-0">
          <a onClick={()=>this.navigateTo('content',content.uid)}><span><u>{content.title}</u></span></a>&nbsp;
          <span>shared</span> to&nbsp;
          <span onClick={()=> this.navigateTo('customer', customer.uid)}><u>{customer.name}</u></span>&nbsp;
          <span>via {act.channel}</span>
        </p>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <span style={styles.text_muted}>{timeago}</span>
      </div>
      <div className="text-center d-flex justify-content-around align-items-center">
        <User size={20} onClick={()=>this.navigateTo('customer', customer.uid)} />
        <BookOpen size={20} onClick={()=>this.navigateTo('content', content.uid)}/>
      </div>
    </div>
    }

    const attendedComp = (act:IActivity) => {
      const customer = act.secondaryActors[0];
      const meeting = act.meeting || {};
      const timeago = Util.getSocialDate(act.time);
      return <div style={styles.grid}>
      <div className="text-left">
        <span className="mr-2" style={styles.badge_attended}>Attended</span>
      </div>
      <div className="d-flex align-items-center">
        <p className="mb-0">
          <span onClick={()=>this.navigateTo('','')}><u>{customer.name}</u></span>&nbsp;
          <span>attended</span>&nbsp;
          <span><u>{meeting.title}</u></span> for&nbsp;
          <span>{meeting.duration} mins</span>
        </p>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <span style={styles.text_muted}>{timeago}</span>
      </div>
      <div className="text-center d-flex justify-content-around align-items-center">
        <User size={20} onClick={()=> this.navigateTo('','')} />
        <Calendar size={20} />
      </div>
    </div>
    }

    const invitedComp = (act:IActivity) => {
      const customer = act.secondaryActors[0];
      const meeting = act.meeting || {};
      const invitedOn = Util.getExactDate(act.meeting.invitedOn);
      const timeago = Util.getSocialDate(act.time);
      return <div style={styles.grid}>
      <div className="text-left">
        <span className="mr-2" style={styles.badge_invited}>Invited</span>
      </div>
      <div className="d-flex align-items-center">
        <p className="mb-0">
          <span onClick={()=>this.navigateTo('','')}><u>{customer.name}</u></span>&nbsp;
          <span>invited for</span>&nbsp;
          <span>{meeting.title} </span> on&nbsp;
          <span>{invitedOn}</span>
        </p>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <span style={styles.text_muted}>{timeago}</span>
      </div>
      <div className="text-center d-flex justify-content-around align-items-center">
        <User size={20} onClick={()=> this.navigateTo('','')} />
        <Calendar size={20} />
      </div>
    </div>
    }

    const renderActivities = activities && activities.length > 0 ? activities.map((act, i)=> {
      const actType = act.activityType;
      if(actType === 'MEETING_INVITED'){
        return <div key={i}>{invitedComp(act)}</div>
      }else if(actType === 'MEETING_ATTENDED'){
        return <div key={i}>{attendedComp(act)}</div>
      }else if(actType === 'CONTENT_VISITED'){
        return <div key={i}>{visitedComp(act)}</div>
      }else if(actType === 'CONTENT_SHARED'){
        return <div key={i}>{sharedComp(act)}</div>
      }
    }) : noData;
    
    
    return(
      <div className="library-content">
        <PaginatorComp paginator={paginator} 
          onNext={this.onNext}
          onPrev={this.onPrev}
          goToPage={this.goToPage}/>
        <Card style={{minHeight: "100vh"}}>
          <CardBody className="p-2">
            {screen.isLoading ? loading : renderActivities}
          </CardBody>
        </Card>  
      </div>
    );
  }
}

export default ActivityList;